import { createTheme } from "@mui/material/styles";

export const Theme = createTheme({
    typography: {
        fontFamily: ['Montserrat', 'sans-serif'].join(','),
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        fontWeightBold: 700,
    },
    palette: {
        primary: {
            light: '#D4EFFF',
            main: '#0050DA',
            dark: '#0843A0',
        }
    },
    components: {
        MuiTooltip: {
            defaultProps: {
                enterDelay: 500,
                enterNextDelay: 500,
                leaveDelay: 200,
            },
        },
    }, 
}) 